import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAI, GoogleAIBackend } from "firebase/ai";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider, AppCheck } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyAkOHweTk8q71bwWWQIT0yrTHaJkPF2RII",
  authDomain: "bee-happy-preschool.firebaseapp.com",
  projectId: "bee-happy-preschool",
  storageBucket: "bee-happy-preschool.firebasestorage.app",
  messagingSenderId: "1155383057",
  appId: "1:1155383057:web:1239be824d8334774696b0",
  measurementId: "G-GM0GG1ZW7R"
};

// App Check reCAPTCHA v3 site key. Public, like the apiKey above.
// Firebase Console -> App Check -> Apps -> register this web app with reCAPTCHA v3.
const APP_CHECK_SITE_KEY = "6LdTLn0tAAAAAIzdfAJR7H3z5nAwvJuzZLsLioL-";

const app = initializeApp(firebaseConfig);

// App Check must be initialized before the services that need to attach its
// tokens (Firestore, Firebase AI Logic).
const initAppCheck = (): AppCheck | undefined => {
  if (import.meta.env.DEV) {
    // Prints a debug token to the console on first run; register it under
    // App Check -> Apps -> Manage debug tokens. Set VITE_APPCHECK_DEBUG_TOKEN in
    // web/.env.local to reuse a token you have already registered.
    (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN =
      import.meta.env.VITE_APPCHECK_DEBUG_TOKEN || true;
  }

  if (APP_CHECK_SITE_KEY.startsWith("REPLACE_WITH_")) {
    console.warn(
      "⚠️ App Check is not configured: set APP_CHECK_SITE_KEY in web/firebase-config.ts. " +
      "Requests will fail once App Check enforcement is switched on."
    );
    return undefined;
  }

  try {
    return initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(APP_CHECK_SITE_KEY),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (error) {
    // Re-initialization during a Vite hot reload is harmless.
    console.warn("App Check initialization skipped", error);
    return undefined;
  }
};

const appCheck = initAppCheck();

const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);
// Firebase AI Logic, using the Gemini Developer API backend
const ai = getAI(app, { backend: new GoogleAIBackend() });
// Cloud Functions live in London, matching the functions project's region.
const functions = getFunctions(app, "europe-west2");
export { db, auth, analytics, ai, appCheck, functions };
